<template>
    <el-form :model="form" ref="form" :rules="rules" :inline="true" size="mini">
        <el-form-item :label="$t('orders.shippingCost')" prop="shippingCharges">
            <el-input v-model.number="form.shippingCharges"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">{{$t('common.save')}}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        name: 'shipping-info',
        data() {
            return {
                form: {
                    shippingCharges: ''
                },
                rules: {
                    shippingCharges: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseEnterCost'),
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        methods: {
            submit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit('update', this.form);
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ClientApp/app/orders/components/ShippingInfo.vue